/** WANアドレスと同一の値ではないことをチェック */
export default {
  validate(
    value: string | undefined | null,
    { wan }: { wan: string | undefined | null }
  ): boolean {
    if (!value || !wan) {
      return true;
    }
    return value !== wan;
  },
};
